import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';


export default function TokenPreview(props) {
    const [nftOwnerKeyId, setNftOwnerKeyId] = useState(null);

    useEffect(() => {
        setNftOwnerKeyId(props.nftOwnerKeyId);
    }, [props.nftOwnerKeyId])
    
    return(
	<>
        <div className="lg:flex lg:items-center lg:justify-between py-5 mx-20 hover:bg-gray-200">
            <div className="flex-1 min-w-0">
                <h3 className="text-md font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate mx-3">
                { props.protocol === 'plot' ? (props.metadata ? 'Plot '+ props.metadata.plot : nftOwnerKeyId)
                : props.metadata.owner }
                </h3>
            </div>
            <div className="mt-5 flex lg:mt-0 lg:ml-4">
                <span className="sm:ml-3">
                    <Link to={ "/nft/" + props.protocol + '/' + props.nftid } type="button" className="inline-flex items-center mx-4 px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-700 hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        <svg className="-ml-1 mr-2 h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fillRule="evenodd" d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z" clipRule="evenodd" />
                        </svg>
                        Details
                    </Link>
                </span>    
            </div>
        </div>
	</>
    );
}

